const state = {
    userInfo: JSON.parse(sessionStorage.getItem('userInfo') || '{}')||{},
	  token: sessionStorage.getItem('Token') || false,
    chat_cai:0,
    chat_uid:0,
}

const mutations = {
   setToken(state, token) {
      state.token = token;
      sessionStorage.setItem('Token',token);
   },
   setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
      sessionStorage.setItem('userInfo',JSON.stringify(userInfo));
   },
   setLogout(state,logout) {
      state.token = false;
      state.userInfo = {};
      sessionStorage.removeItem('Token')
      sessionStorage.removeItem('userInfo')
   },
   setChatCai(state, cai_id) {
      state.chat_cai = cai_id;
   },
   setChatUid(state, user_id) {
      state.chat_uid = user_id;
   },
}

const actions = {

}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js